import { DisplayObject, IDestroyOptions } from "pixi.js";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { FixedSizeContainer } from "../common/components/FixedSizeContainer";
import { Scales } from "../../../canvas/CanvasScaler";
import { TelemetryLayer } from "by/gamefactory/scene/layer/TelemetryLayer";

export class CityverseTycoonTelemetryLayer extends TelemetryLayer {
    private content: FixedSizeContainer;
    private canvasScaler: ICanvasScaler;
    private readonly fixedWidth: number;
    private readonly fixedHeight: number;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.canvasScaler = canvasScaler;
        this.fixedWidth = this.canvasScaler.referenceWidth;
        this.fixedHeight = this.canvasScaler.referenceHeight;
        this.content = this.addChildAt(new FixedSizeContainer(this.fixedWidth, this.fixedHeight), 0);
        this.onResize(canvasScaler.getSize());
        this.canvasScaler.onResize.add(this.onResize, this);
    }

    private onResize(size: Scales): void {
        this.height = size.height;
        this.width = size.width;
        this.position.set(Math.floor((this.canvasScaler.browserWidth - this.width) * 0.5), -this.canvasScaler.safeAreaOffset);
    }
    
    public override addChild<U extends DisplayObject[]>(...children: U): U[0] {
        children.forEach((child) => {
            this.content.addChild(child);
        });
        return children[0];
    }

    public override removeChild<U extends DisplayObject[]>(...children: U): U[0] {
        children.forEach(child => {
            this.content.removeChild(child);
        });
        return children[0];
    }

    public override setChildIndex(child: DisplayObject, index: number): void {
        this.content.setChildIndex(child, index);
    }

    public override calculateBounds(): void {
        this._bounds.clear();
        this._calculateBounds();
        this._bounds.updateID = this._boundsID;
    }

    protected override _calculateBounds(): void {
        this._bounds.addFramePad(0, 0, this.fixedWidth, this.fixedHeight, 0, 0);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.canvasScaler.onResize.remove(this.onResize, this);
        super.destroy(options);
    }
}
